import { container, title } from "../../assets/jss/material-kit-react.jsx"

const ContainerStyle = {
  sections: {
    padding: "70px 0",
  },
  container,
  title: {
    ...title,
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
}

export default ContainerStyle
